module.exports = __webpack_public_path__ + "img/img_tengxun@2x.4242f7cc.png";